import { NavLink } from "react-router";
import { Trans } from "react-i18next";
import classNames from "classnames";
import { useOriginalPathname } from "app/hooks/i18n";

const Link = (props) => {
  const pathname = useOriginalPathname();
  const isPathActive = props.to.includes(pathname);
  return (
    <NavLink
      {...props}
      className={({ isActive }) =>
        classNames(
          "secondary-header-btn rtl:mr-0 rtl:ml-10",
          isActive || isPathActive ? "active" : ""
        )
      }
    />
  );
};

const FeaturesHeader = () => {
  return (
    <nav
      className="sticky top-[30px] z-[40] overflow-x-scroll bg-white
      shadow-secondary-header sm:top-16 md:overflow-x-hidden"
    >
      <div className="zbooni-layout whitespace-nowrap pt-16 md:pt-4">
        <Link to="/features/capture-orders/#details">
          <Trans>Capture Orders</Trans>
        </Link>
        <Link to="/features/accept-payments/#details">
          <Trans>Accept Payments</Trans>
        </Link>
        <Link to="/features/sell-more/#details">
          <Trans>Sell More</Trans>
        </Link>
        <Link to="/features/track-everything/#details">
          <Trans>Track Everything</Trans>
        </Link>
      </div>
    </nav>
  );
};

export default FeaturesHeader;
